import { useLDFlags } from '@/app/core/hooks/useLDFlags'
import {
  Avatar,
  Dropdown,
  DropdownDivider,
  DropdownItem,
} from '@/dc-shared-web/src'
import { useGetUserProfileById } from '@/dc-shared-web/src/hooks/api/user/useGetUserProfileById'
import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import {
  faArrowRightFromBracket,
  faLock,
  faUser,
} from '@document-crunch/pro-regular-svg-icons'
import { useRouter } from 'next/navigation'
import { useMemo } from 'react'

export const UserProfileMenu = () => {
  const router = useRouter()
  const { user: authUser } = useAuth()
  const { data: userProfile } = useGetUserProfileById({
    userId: authUser.uuid,
  })
  const {
    flags: { rd1188ChangePasswordUpdate },
  } = useLDFlags()

  const handleLogout = () => {
    window.location.href = '/logout'
  }

  const changePasswordPath = rd1188ChangePasswordUpdate
    ? '/update-password'
    : '/change-password'

  /* authUser includes the user's name but we don't use it here since the user might update their profile. In that case, the useGetUserProfileById query will be refetched and the name will be updated. */
  const nameFallback = useMemo(() => {
    if (!userProfile) {
      return ''
    }

    return `${userProfile.firstName[0]}${userProfile.lastName[0]}`.toUpperCase()
  }, [userProfile])

  const ssoEnabled = useMemo(() => {
    return authUser?.teams?.some((team) => team.entitlements?.use_sso)
  }, [authUser])

  return (
    <Dropdown
      contentAlign='end'
      trigger={
        <div className='tw-cursor-pointer'>
          <Avatar
            src={userProfile?.picture ?? undefined}
            fallback={nameFallback}
            fallbackColor='blue'
            size='sm'
          />
        </div>
      }
    >
      <DropdownItem
        icon={faUser}
        onClick={() => {
          router.push('/user-profile')
        }}
      >
        My profile
      </DropdownItem>
      {!ssoEnabled && (
        <DropdownItem
          icon={faLock}
          onClick={() => {
            router.push(changePasswordPath)
          }}
        >
          Change password
        </DropdownItem>
      )}
      <DropdownDivider />
      <DropdownItem onClick={handleLogout} icon={faArrowRightFromBracket}>
        Logout
      </DropdownItem>
    </Dropdown>
  )
}
